export default "__VITE_ASSET__BkeqzLY6__"